import { GenerationMode } from "../image/enums.mjs";
import { ImageCreateCoreSchema } from "../image/request.mjs";
import { taskOutputSchema } from "../task/output.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/internal/image.ts
const moderationPolicySchema = z.enum(["force"]);
const detectionSceneSchema = z.enum([
	"tag",
	"message",
	"artwork_text",
	"crawler_artwork_text",
	"model_text",
	"ocr_text",
	"prompt_strict",
	"prompt_lax",
	"kaisou_text_message"
]);
const InternalCreateBaseSchema = z.object({
	userId: z.string(),
	source: z.string().optional(),
	creditAmount: z.int().min(0).optional(),
	kotoneDetectionScene: detectionSceneSchema.optional(),
	priority: z.int().optional(),
	inferenceProfile: GenerationMode.optional(),
	moderationPolicy: moderationPolicySchema.optional()
});
const internalImageCreateInputSchema = ImageCreateCoreSchema.extend({
	...InternalCreateBaseSchema.shape,
	modelVersionId: z.string().min(1),
	width: z.int().min(1),
	height: z.int().min(1),
	batchSize: z.int().min(1).max(4).default(1)
});
const internalImageContract = oc.prefix("/internal/task/image").tag("InternalTask").router({ create: oc.route({
	summary: "Create an image generation task on behalf of a user",
	method: "POST",
	path: "/create",
	outputStructure: "detailed"
}).input(internalImageCreateInputSchema).output(z.object({
	status: z.literal(201),
	body: taskOutputSchema
})).errors({
	USER_NOT_FOUND: {
		status: 404,
		message: "User not found"
	},
	CREATION_FAILED: {
		status: 500,
		message: "Task creation failed"
	}
}) });
//#endregion
export { InternalCreateBaseSchema, internalImageContract, internalImageCreateInputSchema };
